import React from 'react'
import { StyledOverlay, OverlayProps } from './styled'

const Index: React.FC<OverlayProps> = (props: OverlayProps) => {
  return (
    <StyledOverlay {...props}>
      {props.children}
    </StyledOverlay>
  )
}

export default Index
